<div class='sso-forgot-password'>
  <ng-container *ngIf='!passwordSent'>
    <h2>{{localeTexts?.forgotPassword?.forgotPassword}}</h2>
    <p>{{localeTexts?.forgotPassword?.enterEmail}}</p>
    <form 
      [formGroup]="form" 
      (ngSubmit)='onSubmit()'
      class='sso-forgot-password-form'
    >

      <div *ngIf='errorMessage' class='sso-error-message' role="alert">
        <mat-icon aria-hidden='true'>error</mat-icon>
        <div>{{errorMessage}}
          <ng-container *ngIf='errorCustomerSupportInactive'>
            <a [href]='localeTexts?.errors?.customerSupportLinkUrl' target='_blank'>
              {{localeTexts?.errors?.customerSupportLink}}
            </a>
            {{localeTexts?.errors?.userInactiveCombinedEnd}}
          </ng-container>
          <ng-container *ngIf='errorCustomerSupportLocked'>
            <a [href]='localeTexts?.errors?.customerSupportLinkUrl' target='_blank'>
                {{localeTexts?.errors?.customerSupportLink}}
            </a>
            {{localeTexts?.errors?.customerSupportLinkEndLocked}}
          </ng-container>
          <ng-container *ngIf='errorShowActivatedLink'>
            <a *ngIf='errorShowActivatedLink' (click)='sendActivationLink($event)' href=''>
              {{localeTexts?.errors?.userNotActivatedLink}}
            </a>
            {{localeTexts?.errors?.userNotActivatedEnd}}
          </ng-container>
        </div>
      </div>
      
      <div class='sso-row'>
        <aa-input
          [id]="'sso-forgot-password-email-input'"
          [labelText]="localeTexts?.main?.email"
          formControlName="email"
          [type]="'email'"
          [form]="form"
          [maxLength]='64'
          [autocomplete]="'email'"
          [focusOnInit]='true'
          [error]='errorMessage ? true : false'
        >
        </aa-input>
      </div>
      <div class='sso-row'>
        <button type='submit' #submitButton class='sso-button' [disabled]='isLoading'>
          <mat-spinner *ngIf='isLoading' class='white-spinner' [diameter]="22"></mat-spinner>
          <ng-container *ngIf='!isLoading'>
            {{localeTexts?.forgotPassword?.sendResetLink}}
          </ng-container>
        </button>
      </div>
    </form>
  </ng-container>


  <ng-container *ngIf='passwordSent'>
    <h2>{{localeTexts?.forgotPassword?.checkYourEmail}}</h2>
    <p>{{(localeTexts?.forgotPassword?.linkToResetYourPassword).replace("{email}", ""). replace(" {}", ":")}}</p>
  
    <div class='sso-forgot-password-check'>
      <mat-icon>check</mat-icon> 
      <div>{{form.value.email}}</div>
    </div>

    <p>{{localeTexts?.forgotPassword?.kindlyClickLink}}</p>
  </ng-container>



  <div>
    <a href='' (click)='clickBackToLogin($event)'>
      <span aria-hidden='true'>‹ </span>{{localeTexts?.forgotPassword?.backToLogin}}
    </a>
  </div>
</div>